"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./slimscroll.directive"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/~/angular-io-slimscroll/index.js
// module id = ../../../../angular-io-slimscroll/index.js
// module chunks = 4